import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { NgxSpinnerComponent } from "ngx-spinner";
import { NewUiAppComponent } from "./new-ui-app.component";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  imports: [NgxSpinnerComponent, RouterOutlet],
})
export class AppComponent extends NewUiAppComponent {}
